export const messages = {
  ERROR_NETWORK: "Network Error",
  SUCCESSFULLY_SAVED: "Successfully saved",
  SUCCESS_CONNECTED: "Successfully connected",
  FIELD_REQUIRED: "Ce champ est requis",
};
